module.exports = __webpack_public_path__ + "img/6.5f944749.jpg";